module.exports = __webpack_public_path__ + "img/bu-head-job-details-withheld.f7e0c49e.svg";